import { useCallback, useState } from 'react';

// import { useTracking } from '@change-corgi/core/react/tracking';

type UseEndorsementsBannerReturn = ModelHookResult<{ isDismissed: boolean }, { handleDismiss: () => void }>;

export function useEndorsementsBanner(): UseEndorsementsBannerReturn {
	// const track = useTracking();
	const [isDismissed, setIsDismissed] = useState(false);

	const handleDismiss = useCallback(() => {
		// void track('starter_dashboard_endorsements_banner_dismiss_click');
		setIsDismissed(true);
	}, []);

	return {
		data: { isDismissed },
		actions: { handleDismiss },
	};
}
